export const NO_CARS_TITLE_TEXT = "No cars found";
export const NO_CARS_SUBTITLE_TEXT =
  "Please search again to view available cars.";
export const RESET_BUTTON_TEXT = "Reset filters";
export const SEARCH_AGAIN_BUTTON_TEXT = "Search again";
